import React, { useState, useEffect } from 'react';
import './App.css';

import { BrowserRouter, Routes, Route  } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Header from './components/sections/HeaderSection';
import Footer from './components/sections/FooterSection';

import HomePage from './components/pages/Home';
import AccessbilityPolicyPage from './components/pages/AccessibilityPolicy';
import AboutPage from './components/pages/About';
import CartPage from './components/pageoverlays/Cart';
import ContactPage from './components/pages/Contact';
import ForumPage from './components/pages/Forum';
import InventoryPage from './components/pages/Inventory';
import InventoryByCategoryPage from './components/pages/InventoryByCategory';
import InventoryItemPage from './components/pages/InventoryItem';
import NotFoundPage from './components/pages/NotFound';
import PrivacyPage from './components/pages/Privacy';


/**  const apiUrl = process.env.REACT_APP_API_URL; */



/* First Verify Users Age */
import Cookies from 'universal-cookie';
import { getCSRF } from './hooks/CSRFhook';
import { GetSessionID, SetSessionID } from './hooks/SessionID';
import axios from "axios";
import UserVerifyPage from './components/pages/UserVerify';
import { GetHeaders, PostDataFetch } from './hooks/DataFetch';
import { INTRFUser } from './hooks/Interfaces';
/* Date of Birth Verification */
function setAgeVerify(value: string){
  const cookies = new Cookies();
  cookies.set('dobver', value)
}

interface ApplicationProps {
  user: INTRFUser;
  updatefunc: () => void;
}

function Application({user, updatefunc}: ApplicationProps) {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<InventoryByCategoryPage updatefunc={updatefunc} />} />
          <Route path="/home" element={<InventoryByCategoryPage updatefunc={updatefunc} />} />
          <Route path="/accessibility" element={<AccessbilityPolicyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/inventory" element={<InventoryPage updatefunc={updatefunc} />} />
          <Route path="/inventory/featured" element={<InventoryByCategoryPage updatefunc={updatefunc} />} />
          <Route path="/inventory/search/:category" element={<InventoryByCategoryPage updatefunc={updatefunc} />} />
          <Route path="/inventory/item/:productid" element={<InventoryItemPage updatefunc={updatefunc} />} />
          <Route path="/network" element={<ForumPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cart" element={<CartPage user={user} updatefunc={updatefunc} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
  )

}
function App() {
  const cookies = new Cookies();
  let [canview, setView] = useState(false);
  let [user, setUser] = useState<INTRFUser>({username: "", name: "", loggedin: false, address: {address1: "", address2: "", city: "", state:"",zip:""}});
  let [cartcount, setCartCount] = useState(0);

  /* */
  let [csrfcookie, setCSRFCookie] = useState(getCSRF());
  let [sessioncookie, setSessionCookie] = useState(GetSessionID());

  //let [categories, setCategoriesFilter] = useState(Array<CategoryProps>);
  const UpdateAppState = async () => {
        //setLoading(true);
        let axiosConfig = GetHeaders();
        const posturl = process.env.REACT_APP_API_URL + "/v1/session/info"
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: {}})

        //Handle a Non 200 response
        if(200 == response.status) {
          setUser({
            username: response.session_state.username, 
            name: response.session_state.username, 
            loggedin: response.session_state.loggedin, 
            address: response.session_state.address
          })
          setCartCount(response.session_state.items)
        }else{
          //Error handling
        }
    }

  const updateState = (): void => {
    UpdateAppState();
  }

  /* Component Init */
  useEffect(() => {
    // If it is defined.
    console.log("Updating Session Cookie")
    console.log(sessioncookie)

    {GetSessionID() && SetSessionID(GetSessionID()) }
    {sessioncookie && SetSessionID(sessioncookie) }
    
    //Check for valid cookie
    if(!canview && cookies.get('app-session')){
      setView(true);
    }

    UpdateAppState();
      
  }, [cartcount, csrfcookie, sessioncookie]);

  return (
    <>
      
      <div className="App">
        {canview &&
          <Header user={user} carteditems={cartcount} appupdatefunc={updateState} updatecsrf={setCSRFCookie} updatesession={setSessionCookie}></Header>
        }
        <Container fluid>
          <Row className='block-main-content bg-white'>
            <Container>
              {canview ? <Application user={user} updatefunc={updateState} /> : <UserVerifyPage submit={setView} updatecsrf={setCSRFCookie} updatesession={setSessionCookie} /> }
            </Container>
          </Row>
          <Footer></Footer>
        </Container>
      </div>
      </>
  );
}


export default App;
